import React, { useEffect, useState } from "react";
import {Row, Col, Card, CardBody, Button, Form, FormGroup, Label, Input,Spinner} from "reactstrap";
import Dropzone from "react-dropzone";

import { httpGet, httpUpload,httpPost } from "../../../common/petitions";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Models from './model.json';
import "../tables.scss";
import "../Puestos.scss";
import DataLoader from "../../../components/tableData";
import { useNavigate } from 'react-router-dom';
import useUpdateCreateAlert from '../../../components/alerts';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { saveAs } from "file-saver";
import EditModal from "./EditModal";
const Digiforms = () => {
  const [filterData, setFilersData] = useState([]);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');
  const [uploadResult, setUploadResult] = useState(null);
  const [data, setData] = useState(null);

  const [dataErros, setDataErros] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [weeks,setWeeks] = useState([])
  const [weeksUp,setWeeksUp] = useState('')

  const [filters, setFilters] = useState({ coordinacion: '', caporal: '', fecha: {init:'',end:''} });
  const navigate = useNavigate();
  const [filteredCaporal, setFilteredCaporal] = useState([]); 
  const [selectedCoordinacion, setSelectedCoordinacion] = useState('');
  const [selectedCaporal, setSelectedCaporal] = useState('');

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);


   const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
  useUpdateCreateAlert(status, message);
const handleEdit = async (row) => {
  try {
    const rowData = await await httpGet(`/digiforms/mq/filtersup`, navigate);

    if (!response.ok) {
      throw new Error('Error fetching row data');
    }

    const formattedData = data.columns.reduce((acc, col) => {
      acc[col.field] = rowData[col.field] || "";
      return acc;
    }, {});

    setFormData(formattedData);
    setModalOpen(true);
  } catch (error) {
    console.error("Error fetching row data:", error);
  }
};

   const downloadErrorsAsCSV = (dataErros) => {
      if (!dataErros || !dataErros.rows.length) return;
    
      const csvHeaders = dataErros.columns.map(col => col.label).join(",");
      const csvRows = dataErros.rows.map(row => 
        dataErros.columns.map(col => row[col.field] || "").join(",")
      );
    
      const csvContent = [csvHeaders, ...csvRows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "errors.csv");
    };
  const fetchData = async (filtro) => {
    setIsLoading(true);
    try {
      // console.log(filtro);
      
      const rowsData = await httpPost(`/digiforms/mq/listed`,filtro, navigate);
      // const coordinations = await httpGet(`/digiforms/mq//coordination`, navigate);
      // console.log(rowsData);
      const jsonData = { "columns": Models, "rows": rowsData };
      // setFilersData(coordinations)
      setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  }

  const fetchWeeks = async () => {
    try {
      // console.log(filtro);
      
      const getFilters = await httpGet(`/digiforms/mq/filtersup`, navigate)
      // console.log(getFilters.weeks['09']);
      setWeeks(getFilters.weeks['09'])
      // setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleSearch = () => {
    const filt = {fecha:filters.fecha,coordinacion: selectedCoordinacion,caporal: selectedCaporal}
    // console.log(filters.fecha.init != '');
    if((filters.fecha.init !='' && filters.fecha.end !='')||
       (filters.fecha.init =='' && filters.fecha.end =='')
    ){
      // console.log(filt);
      
      setFilters(filt)
    fetchData(filt)
    }
    
    
  };

  const uploadFile = async (file) => {
    // console.log('sss',weeksUp);
    
    if(weeksUp !== '')
    {
      const formdata = new FormData();
      formdata.append("file", file);
      formdata.append("weeksUp", weeksUp);
      try {
        setIsUploading(true);
        const result = await httpUpload(`/digiforms/mq/import`, formdata, navigate);
        // console.log(result);
        
        setUploadResult(result);
        fetchData(filters);
        setIsUploading(false);
        setMessage('Datos cargados correctamente!');
        setStatus('created');
        // setWeeksUp('')
        if(result.errors.length > 0){
        console.log(result.errors);
        if (result.errors && result.errors.length) {
            const errorsCols = [...Models,{
                                          "label": "Error",
                                          "field": "error_response"
                                      }]
            setDataErros({ "columns": errorsCols, "rows": result.errors })
          }
        }
      } catch (error) {
        // console.log("Error uploading file:", error);
        setMessage('Error al subir el archivo: ' + error.message );
        setStatus('error');
      setIsUploading(false);
      } finally{
        // setStatus(null)
        // setMessage("")
      }
    }else{
      alert('Debe elegir una semana')
    }
    
  };

  const handleAcceptedFiles = (files) => {
    const file = files[0];
    uploadFile(file);
  };

  // const handleFilterChange = (e) => {
  //   const { name, value } = e.target;
  //   setFilters(prev => ({ ...prev, [name]: value }));
  // };

  const handleDateChange = (date, type) => {
    setFilters(prev => ({
        ...prev,
        fecha: {
            ...prev.fecha,
            [type]: date
        }
    }));
};

  const handleidcatChange = (e) => {
    // const selectedId = parseInt(e.target.value, 10); 
    // setSelectedCoordinacion(selectedId);
    // const filtered = filterData.filter(item => item.id_coordinacion === selectedId);
    // setFilteredCaporal(filtered);
  };
  const handleidmaqChange = (e) => {
    // const selectedId = parseInt(e.target.value, 10); 
    // setSelectedCaporal(selectedId);
  };



  const handleWeek = (e) => {
    const values = e.target.value
    // console.log(values);
    setWeeksUp(values)
    // const selectedId = parseInt(e.target.value, 10); 
    // // console.log(e.target.value);
    // setSelectedCaporal(selectedId);
  };



 
  useEffect(() => {
    fetchData(filters);
    fetchWeeks()
  }, []);

  // Keyboard shortcut to trigger search with F8
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F8") {
        e.preventDefault();
        handleSearch();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  document.title = "Digiforms - Maquinria - IPG";
  // style={{borderColor:'red',borderWidth:'1px',borderStyle: 'solid'}}
  return (
    <React.Fragment>
      <div className="page-content" >
      {/* <EditModal 
            isOpen={editModalOpen} 
            toggle={() => setEditModalOpen(false)} 
            rowId={selectedRowId} 
            columns={Models.columns} 
            apiEndpoint="https://api.example.com/rows" 
            // onSave={reload} 
          /> */}
        <div className="container-responsive" >
          <Breadcrumbs maintitle="Digiforms" title="Maquinaria" />

          <Row>
          <Col md="6">
              <Card>
                <CardBody>
                <FormGroup className=" align-items-center me-1">
                      <Label for="coordinacion" className="me-2 mb-0">Semana:</Label>
                      <Input 
                        type="select" 
                        name="coordinacion" 
                        id="coordinacion" 
                        onChange={handleWeek}
                      >
                        <option value="">--Seleccionar--</option>
                        {weeks.map((semana, index) => (
                          <option 
                            key={index} 
                            value={`${semana.f_desde} / ${semana.f_hasta}`}
                          >
                            {semana.descripcion}
                          </option>
                        ))}
                      </Input>
                  </FormGroup>
                  <Dropzone onDrop={handleAcceptedFiles}>
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone-container">
                          <div className="btn btn-success dropzone me-5" {...getRootProps()}>
                            <input {...getInputProps()} />
                            <span>
                              {isUploading ? (
                                <Spinner color="light" style={{ width: '2rem', height: '2rem' }} />
                              ) : (
                                "Subir archivo"
                              )}
                            </span>
                          </div>
                          {uploadResult && (
                            <div className="upload-check">
                              <i className="bx bx-check-circle"></i>
                            </div>
                          )}
                        </div>
                      )}
                  </Dropzone>
                </CardBody>
              </Card>
            </Col>
            <Col md="6">
              <Card>
                <CardBody>
                  <Form className="align-items-center">
                  <Col md="12" className="d-flex">
                    <FormGroup className=" align-items-center me-1">
                      <Label for="idcategoria" className="me-2 mb-0">Id categoria:</Label>
                      <Input 
                        type="select" 
                        name="idcategoria" 
                        id="idcategoria" 
                        onChange={handleidcatChange}
                      >
                        <option value="">--Seleccionar--</option>
                        {/* {[...new Set(filterData.map(item => item.id_idcategoria))].map((id,val) => (
                          <option key={id} value={id}>
                            [{filterData.find(item => item.id_idcategoria === id)?.id_idcategoria}] {filterData.find(item => item.id_idcategoria === id)?.descripcion}
                          </option>
                        ))} */}
                      </Input>
                    </FormGroup>
                    
                    <FormGroup className=" align-items-center me-1">
                      <Label for="idmaquinaria" className="me-2 mb-0">Id maquinaria:</Label>
                      <Input type="select" name="idmaquinaria" id="idmaquinaria"
                      onChange={handleidmaqChange}
                      >
                        <option value="">--Seleccionar--</option>
                        {/* {filteredidmaq.map(item => (
                          <option key={item.id_empleado} value={item.id_empleado}>
                           [{item.id_empleado}] {item.nombre}
                          </option>
                        ))} */}
                      </Input>
                    </FormGroup>
                    </Col>
                    <Col md="12" className="d-flex">
                    <FormGroup className="align-items-center me-3">
                      <Label for="fecha" className="me-2 mb-0">Desde:</Label>
                      <DatePicker
                        selected={filters.fecha.init}
                        onChange={(date) => handleDateChange(date, 'init')}
                        placeholderText="Seleccionar fecha"
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                      />
                    </FormGroup>
                    <FormGroup className="align-items-center me-3">
                      <Label for="fecha" className="me-2 mb-0">Hasta:</Label>
                      <DatePicker
                        selected={filters.fecha.end}
                        onChange={(date) => handleDateChange(date, 'end')}
                        placeholderText="Seleccionar fecha"
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                      />
                    </FormGroup>
                    </Col>
                    <Button color="primary" onClick={handleSearch}>Buscar</Button>
                  </Form>
                  </CardBody>
              </Card>
            </Col>
            
          
            {/* File Upload and Data Table */}
            <Col className="col-12">
              <Card>
                <CardBody>
                {dataErros && (
                              <div>
                                <h5 className="text-danger">Errores en la carga de datos</h5>
                                <Button color="danger" onClick={() => downloadErrorsAsCSV(dataErros)}>Descargar errores CSV</Button>
                              </div>
                            )}
                <h3 className="text-success">Datos</h3>
                  {data && <DataLoader isLoading={isLoading} data={data} hoverColor={'green'} handleEdit={handleEdit}/>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Digiforms;
